import { useEffect, useRef } from 'react';

const Gtm = ({ gtmId }) => {
  const isInjected = useRef(false);

  useEffect(() => {
    // Don't inject if no ID provided
    if (!gtmId) return;

    // Don't inject if already injected (using ref to track across re-renders)
    if (isInjected.current) {
      console.log('GTM already injected, skipping');
      return;
    }

    // Check if GTM script already exists in DOM
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`);
    if (existingScript) {
      console.log('GTM script already in DOM');
      isInjected.current = true;
      return;
    }

    // Check if dataLayer already exists
    if (window.dataLayer && window.dataLayer.length > 0) {
      console.log('GTM dataLayer already initialized');
      isInjected.current = true;
      return;
    }

    console.log('Initializing GTM with ID:', gtmId);

    // Inject GTM script into <head>
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    // Inject noscript into <body>
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);

    // Mark as injected
    isInjected.current = true;

    // Note: Don't clean up GTM on unmount - it should persist for the session
  }, [gtmId]);

  return null;
};

export default Gtm;